import { PurchaseModel } from 'api-hooks/order/common';
import { Input } from 'components/elements';
import OrderSelectInput from 'legacy-modules/order/component/select-input';
import TransactionAt from 'legacy-modules/sales/component/transaction-at';
import { HalfContainer, SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { OrderAdjustmentFormType } from './form-type';

export default function InformationField() {
  const { t } = useTranslation();

  const { setValue, getValues } = useFormContext<OrderAdjustmentFormType>();

  const onChangeOrderDetail = React.useCallback(
    (value: PurchaseModel) => {
      setValue('purchase', value);
      setValue('purchaseId', value.id);
      setValue('purchaseRefId', value.refId);
    },
    [setValue],
  );

  const orderSelectInputComponent = React.useMemo(() => {
    return (
      <OrderSelectInput
        name="purchaseId"
        required
        onAfterDetailChange={onChangeOrderDetail}
      />
    );
  }, [onChangeOrderDetail]);

  const transactionComponent = React.useMemo(() => {
    return (
      <TransactionAt
        name="transactionAt"
        label={t('common:transaction_at')}
        hasTime
        clearable={false}
        required
      />
    );
  }, [t]);

  const numberComponent = React.useMemo(() => {
    return (
      <Input
        type="text"
        name="number"
        label={t('common:adjustment_number')}
        placeholder={t('common:adjustment_number')}
        disabled
      />
    );
  }, [t]);

  const orderAdjustment = getValues('orderAdjustment');
  const number = orderAdjustment?.number;

  return (
    <>
      <>
        <SectionContainer>
          <HalfContainer
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}
          >
            {transactionComponent}
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <HalfContainer>{orderSelectInputComponent}</HalfContainer>
          <HalfContainer>{number && numberComponent}</HalfContainer>
        </SectionContainer>
      </>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text-area"
            name="description"
            label={t('common:description')}
            placeholder={t('common:description')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="number"
            name="amount"
            label={t('common:adjustment')}
            placeholder={t('common:adjustment')}
            required
          />
        </HalfContainer>
      </SectionContainer>
    </>
  );
}
